import React, { useState } from "react";
import founder from "../../assets/images/InternationalAcademy/avatar.png";
import Video from "../../assets/images/InternationalAcademy/video.jpg";
import Pagoda from "../../assets/images/InternationalAcademy/pagoda.jpg";
import { MdHistory } from "react-icons/md";
import { TbWorld } from "react-icons/tb";
import { PiStudentFill } from "react-icons/pi";
import { FaPeopleGroup } from "react-icons/fa6";
import { BsFillPeopleFill } from "react-icons/bs";
import { Element } from "react-scroll";
import { IoIosArrowForward } from "react-icons/io";
const Founder = () => {
  const [selectedCategory, setSelectedCategory] = useState("history");
  const [isOpenReadMore, setOpenReadmore] = useState(false);
  return (
    <Element name="founder">
      <div className="flex flex-col gap-10 bg-[#F2F2F2]">
        <div className="flex md:flex-row flex-col ">
          <div className="md:w-1/2 relative overflow-hidden">
            <div className="relative">
              <img
                src={Video}
                className=" hover:scale-105 transition-all duration-500"
                alt=""
              />
              <div className="absolute top-[42%] left-[46%]">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 448 512"
                  className="text-white"
                  height="40"
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 flex flex-col items-center gap-4 pt-4 px-2">
            <img
              src={
                "https://i.pinimg.com/564x/63/53/d9/6353d9fff14cc31af369dd0254fd8c97.jpg"
              }
              className="w-24 rounded-full h-24"
              alt=""
            />
            <h3 className=" text-lg lg:text-xl font-bold fontstyle2 text-center ">
              SIS Group of Schools Founder
            </h3>
            <p className="lg:px-20 px-10 md:text-sm text-center fontstyle2  md:tracking-wider md:leading-5">
              As the CEO of an International School, my primary purpose is to
              create a transformative educational institution that empowers
              students to excel academically, develop essential life skills, and
              embrace a global perspective.
            </p>
            <button
              onClick={() => setOpenReadmore(true)}
              className={`${
                !isOpenReadMore ? "flex" : "hidden"
              } px-4 py-2  items-center gap-2 bg-slate-300 `}
            >
              <span>
                <IoIosArrowForward />
              </span>{" "}
              READ MORE
            </button>
          </div>
        </div>

        <div
          className={`${
            isOpenReadMore ? "flex" : "hidden"
          } border lg:mx-14 mx-6  flex-col gap-4 py-10 lg:px-10 px-4 fontstyle2 relative `}
        >
          <button onClick={() => setOpenReadmore(false)}>
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 320 512"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"></path>
            </svg>
          </button>
          <h5 className="text-center uppercase tracking-wider text-sm font-medium">
            read more
          </h5>
          <p className="tracking-wide leading-7">
            By opening this International School, I aim to:
          </p>

          <div>
            <h5 className="font-semibold">Provide Quality Education:</h5>
            <p className="tracking-wide leading-7">
              Offer a world-class education that focuses on academic excellence,
              critical thinking, and holistic development. Our curriculum will
              be designed to meet international standards, fostering a deep
              understanding of subjects and promoting lifelong learning.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">Cultivate Global Citizens:</h5>
            <p className="tracking-wide leading-7">
              Nurture students to become global citizens who appreciate cultural
              diversity, possess strong intercultural communication skills, and
              are ready to thrive in an interconnected world. Our school will
              encourage open- mindedness and respect for different cultures and
              viewpoints.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">Foster Innovation and Creativity:</h5>
            <p className="tracking-wide leading-7">
              Create an environment that sparks creativity, innovation, and
              entrepreneurial thinking. By incorporating project-based learning,
              problem-solving challenges, and extracurricular activities, we
              will inspire students to think outside the box and develop a
              passion for learning.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">Promote Character Development:</h5>
            <p className="tracking-wide leading-7">
              Emphasize the importance of character education by instilling
              values such as integrity, empathy, leadership, and responsibility.
              Our school will help students develop into well-rounded
              individuals who contribute positively to their communities.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">
              Offer Diverse Learning Opportunities:
            </h5>
            <p className="tracking-wide leading-7">
              Provide a wide range of academic programs, extracurricular
              activities, and enrichment opportunities to cater to different
              learning styles and interests. This will help students discover
              their passions and talents, fostering a love for learning beyond
              the classroom.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">
              Facilitate Advanced Technology Integration:
            </h5>
            <p className="tracking-wide leading-7">
              Incorporate cutting-edge technology into the learning process,
              preparing students for the digital age. We will equip students
              with digital literacy skills and expose them to emerging
              technologies that will be essential for their future careers.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">
              Build Strong Teacher-Student Relationships:
            </h5>
            <p className="tracking-wide leading-7">
              Foster a supportive and nurturing learning environment where
              teachers act as mentors, guiding students both academically and
              personally. By maintaining small class sizes, we will enable
              personalized attention and meaningful interactions.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">
              Create a Safe and Inclusive Space:
            </h5>
            <p className="tracking-wide leading-7">
              Establish a safe, inclusive, and welcoming campus where every
              student feels valued, respected, and able to express their
              identity. This inclusive environment will enhance collaboration,
              empathy, and understanding among students from diverse
              backgrounds.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">Forge Meaningful Partnerships:</h5>
            <p className="tracking-wide leading-7">
              Collaborate with parents, local communities, universities, and
              industry partners to enrich students' educational experiences. By
              forming strong partnerships, we can offer internships, guest
              lectures, and real-world connections that bridge the gap between
              education and practical application.
            </p>
          </div>
          <div>
            <h5 className="font-semibold">Contribute to Societal Progress:</h5>
            <p className="tracking-wide leading-7">
              Contribute to the advancement of society by nurturing
              well-educated, compassionate individuals who are equipped to
              solvecomplex challenges and make a positive impact. Our graduates
              will become leaders in various fields, driving positive change on
              a local and global scale.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row">
          <div className="md:w-1/2">
            <div className="px-10">
              <div className=" ">
                <ul className="flex justify-center  gap-5 flex-wrap ">
                  <li
                    className={`${
                      selectedCategory === "history"
                        ? "bg-slate-200"
                        : "bg-slate-100/50 "
                    } transition-all   flex items-center  gap-2  cursor-pointer px-3 py-4 `}
                    onClick={() => setSelectedCategory("history")}
                  >
                    <p>
                      <MdHistory size={20} />
                    </p>
                    <p className="uppercase text-sm ">History</p>
                  </li>
                  <li
                    className={`${
                      selectedCategory === "network"
                        ? "bg-slate-200"
                        : "bg-slate-100/50 "
                    } transition-all   flex items-center  gap-2  cursor-pointer px-3 py-4 `}
                    onClick={() => setSelectedCategory("network")}
                  >
                    <p>
                      <TbWorld size={20} />
                    </p>
                    <p className="uppercase text-sm ">Network</p>
                  </li>
                  <li
                    className={`${
                      selectedCategory === "student"
                        ? "bg-slate-200"
                        : "bg-slate-100/50 "
                    } transition-all   flex items-center  gap-2  cursor-pointer px-3 py-4 `}
                    onClick={() => setSelectedCategory("student")}
                  >
                    <p>
                      <PiStudentFill size={20} />
                    </p>
                    <p className="uppercase text-sm ">Curriculum</p>
                  </li>
                  <li
                    className={`${
                      selectedCategory === "teachers"
                        ? "bg-slate-200"
                        : "bg-slate-100/50 "
                    } transition-all   flex items-center  gap-2  cursor-pointer px-3 py-4 `}
                    onClick={() => setSelectedCategory("teachers")}
                  >
                    <p>
                      <FaPeopleGroup size={20} />
                    </p>
                    <p className="uppercase text-sm ">Teachers</p>
                  </li>
                  <li
                    className={`${
                      selectedCategory === "parents"
                        ? "bg-slate-200"
                        : "bg-slate-100/50 "
                    } transition-all   flex items-center  gap-2  cursor-pointer px-3 py-4 `}
                    onClick={() => setSelectedCategory("parents")}
                  >
                    <p>
                      <BsFillPeopleFill size={20} />
                    </p>
                    <p className="uppercase text-sm ">Parents</p>
                  </li>
                </ul>
                <div>
                  <div className="mt-10">
                    <div className="flex flex-col lg:flex-row justify-center fontstyle2 ">
                      <div className="w-full h-full flex flex-col lg:px-10  gap-5">
                        {selectedCategory === "history" && <History />}
                        {selectedCategory === "network" && <Network />}
                        {selectedCategory === "student" && <Student />}
                        {selectedCategory === "teachers" && <Teacher />}
                        {selectedCategory === "parents" && <Parents />}
                      </div>
                    </div>
                  </div>
                  <div className="mt-10"></div>
                  <div className="mt-10"></div>
                  <div className="mt-10"></div>
                  <div className="mt-10"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2">
            <img src={Pagoda} alt="" />
          </div>
        </div>
      </div>
    </Element>
  );
};

export default Founder;

const History = () => {
  return (
    <>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          With its rich history and population of almost 54 million, Myanmar
          (also known as Burma) is renowned for its warm, friendly and hard
          working population. The countryside consists of beautiful mountains,
          scenic plains and lovely islands, beaches, and is one of ASEAN’s
          popular tourist destinations. Yangon, formerly known as Rangoon, is
          the largest city in Myanmar and the busiest commercial centre that is
          strategically located attracting numerous investors and foreign
          investment.
        </p>
      </div>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          SIS Myanmar is the SIS Group of Schools’ next international campus.
          Located in Yangon, in a partnership with SLG Education, a member of
          SLG Holdings, SIS Myanmar aims to prepare local and international
          students for the 21st century. The SIS Group of Schools is the
          region’s most renowned K-12 School group with international and
          private schools in multiple countries. It is in a strategic
          partnership with the International Finance Corporation (World Bank) to
          bring high-end, quality schools at affordable fees to countries across
          the world.
        </p>
      </div>
    </>
  );
};

const Network = () => {
  return (
    <>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          The SIS Group of Schools is fast expanding into Indonesia, Myanmar,
          India, Korea and soon to China, Kazakhstan and Africa. The SIS Group
          of Schools is a network of schools. Networks give greater access to
          resources and promote creative ideas among schools. Students from SIS
          Myanmar will work on projects with their peers in other schools within
          the SIS Group of Schools. Teachers will also collaborate with their
          fellow educators from across the network.
        </p>
      </div>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          This effective eco-system of collaboration was recognized and
          acknowledged by the Financial Times (FT) and the IFC, International
          Finance Corporation (World Bank) when SIS became the only K-12 school
          in the world to be awarded the global 2019 FT-IFC Transformational
          Business Award – Education in London.
        </p>
      </div>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          Our schools are especially designed to stimulate creativity, enhance
          concentration and allow students and teachers to work in teams as well
          as collaborate to allow SIS Programs to achieve their maximum impact.
        </p>
      </div>
    </>
  );
};

const Student = () => {
  return (
    <>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          The SIS Group of Schools adopts 3 world-renowned curricula; the
          Singapore curriculum in the pre-school as well as the primary levels.
          The Singapore system is then complemented by the Cambridge curriculum
          at the secondary school levels. For our high schools (Junior College)
          we adopt the Cambridge A-levels and/or the International Baccalaureate
          Diploma Program (IBDP).
        </p>
      </div>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          Embedded in the curriculum is our PACE initiative which looks to
          develop 21st century skills; Perseverance, Analytical thinking,
          Collaboration / Communication and Entrepreneurism.
        </p>
      </div>
    </>
  );
};

const Teacher = () => {
  return (
    <>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          All SIS teachers are highly qualified and experienced. They are part
          of the diversity of cultures within the school, that we embrace. They
          are passionate about what they teach and have excellent subject
          knowledge.
        </p>
      </div>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          For students who are still working towards the expectations of the
          subject, SIS has an Academic Support Program, where the subject
          teacher will give individual support and attention to the student
          outside of curriculum time. This allows them personalized attention.
        </p>
      </div>
    </>
  );
};

const Parents = () => {
  return (
    <>
      <div className="flex items-center gap-4">
        <p className="text-sm ">
          Parents will always remain the main influence in a child’s learning
          experience and education. In SIS Schools, we encourage parents to
          provide feedback to us on our learner’s experiences and emotions in
          their learning journeys at home. We then work with parents to enhance
          and reinforce their learning to ensure our children are always having
          fun learning both in school and at home.
        </p>
      </div>
    </>
  );
};
